var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 250,
    viewBox: "0 0 205 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_593)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.517,
    height: 233,
    transform: "translate(22.8267) rotate(5.62216)",
    fill: "#FF896F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.8267,
    width: 182.517,
    height: 233,
    transform: "rotate(5.62216 22.8267 0)",
    fill: "#FFD5CC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_593)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.465 17.8807L22.8267 0L0.000170626 231.879L181.639 249.76L204.465 17.8807ZM46.8355 12.1186C37.2307 11.1731 28.6781 18.1928 27.7326 27.7976L10.2323 205.572C9.28675 215.176 16.3064 223.729 25.9112 224.675L157.631 237.641C167.236 238.587 175.789 231.567 176.734 221.962L194.235 44.1883C195.18 34.5835 188.161 26.0309 178.556 25.0853L46.8355 12.1186Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.915 122.228C143.743 137.885 133.525 160.457 112.378 167.991C107.064 169.885 104.47 167.284 98.3148 166.977C92.8155 166.702 90.9347 168.465 85.9055 166.086C65.0214 156.204 57.6445 132.556 58.9007 115.785C60.543 93.8602 79.5742 84.0657 103.271 100.811C127.482 88.4859 146.558 100.303 144.915 122.228Z",
    fill: "#FF542F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.587 96.513C91.8124 88.7614 80.5075 86.7886 71.4589 90.3236C61.8419 94.0806 56.0789 103.539 55.1824 115.507C53.8551 133.228 61.5656 158.695 84.3111 169.457C87.4539 170.944 89.8181 171.186 92.1618 171.043C92.9667 170.994 93.6268 170.923 94.2477 170.857C95.4378 170.731 96.4838 170.619 98.1291 170.701C100.085 170.799 101.466 171.138 103.037 171.523C103.611 171.664 104.21 171.81 104.871 171.954C107.37 172.496 110.104 172.761 113.63 171.504C136.646 163.304 147.396 139.049 148.635 122.507C149.544 110.371 144.686 100.39 135.579 95.4049C127.058 90.741 115.677 90.9212 103.587 96.513ZM112.379 167.991C133.525 160.457 143.743 137.885 144.916 122.229C146.558 100.303 127.482 88.4863 103.271 100.812C79.5747 84.066 60.5435 93.8605 58.9012 115.786C57.645 132.556 65.0219 156.205 85.906 166.086C89.1713 167.631 91.1094 167.429 93.5723 167.173C94.9028 167.035 96.3865 166.88 98.3153 166.977C100.656 167.094 102.481 167.542 104.137 167.949C106.836 168.612 109.085 169.165 112.379 167.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.101 157.274C126.247 149.739 134.814 127.005 135.987 111.348C136.33 106.764 135.768 102.621 134.442 99.048C141.628 103.322 145.714 111.584 144.917 122.228C143.744 137.884 133.526 160.457 112.38 167.991C109.086 169.164 106.837 168.612 104.138 167.949C102.482 167.542 100.657 167.093 98.3162 166.976C96.3874 166.88 94.9037 167.034 93.5731 167.173C91.1102 167.429 89.1721 167.631 85.9069 166.086C78.2684 162.472 72.4369 157.016 68.1738 150.728C70.3307 152.354 72.7096 153.805 75.3264 155.044C78.6943 156.637 81.3906 156.445 84.456 156.227C85.9681 156.12 87.5699 156.006 89.3865 156.097C91.6672 156.211 93.6857 156.662 95.5935 157.088C98.8341 157.813 101.755 158.466 105.101 157.274Z",
    fill: "#ED4A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.003 116.91C132.573 118.691 130.781 119.786 129 119.356C127.219 118.927 126.123 117.135 126.553 115.353C126.983 113.572 128.775 112.477 130.556 112.906C132.337 113.336 133.433 115.128 133.003 116.91Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.998 127.348C140.568 129.129 138.776 130.224 136.995 129.794C135.213 129.365 134.118 127.573 134.548 125.791C134.977 124.01 136.77 122.915 138.551 123.344C140.332 123.774 141.427 125.566 140.998 127.348Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.039 114.823C141.716 116.159 140.372 116.981 139.036 116.659C137.701 116.336 136.879 114.992 137.201 113.656C137.523 112.32 138.868 111.499 140.203 111.821C141.539 112.143 142.361 113.488 142.039 114.823Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.621 138.511C136.191 140.292 134.399 141.387 132.618 140.958C130.837 140.528 129.741 138.736 130.171 136.955C130.6 135.173 132.393 134.078 134.174 134.508C135.955 134.937 137.05 136.73 136.621 138.511Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.626 128.073C128.196 129.854 126.404 130.949 124.623 130.52C122.842 130.09 121.746 128.298 122.176 126.517C122.606 124.736 124.398 123.64 126.179 124.07C127.96 124.499 129.056 126.292 128.626 128.073Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.94 150.491C129.51 152.272 127.718 153.368 125.936 152.938C124.155 152.509 123.06 150.716 123.49 148.935C123.919 147.154 125.711 146.059 127.493 146.488C129.274 146.918 130.369 148.71 129.94 150.491Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.292 139.83C123.862 141.611 122.07 142.706 120.289 142.277C118.507 141.847 117.412 140.055 117.842 138.274C118.271 136.493 120.064 135.397 121.845 135.827C123.626 136.256 124.721 138.049 124.292 139.83Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.673 157.175C122.351 158.511 121.007 159.333 119.671 159.011C118.335 158.688 117.514 157.344 117.836 156.008C118.158 154.673 119.502 153.851 120.838 154.173C122.174 154.495 122.996 155.84 122.673 157.175Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.119 68.8395C125.119 68.8395 127.298 84.3242 122.625 92.1779C116.993 101.644 102.874 100.886 102.874 100.886C102.874 100.886 99.7601 88.8663 106.378 79.3326C111.468 71.9989 125.119 68.8395 125.119 68.8395Z",
    fill: "#7CD623"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.812 68.32L125.119 68.8397L124.278 65.2066C125.297 64.9708 126.368 65.1736 127.23 65.7656C128.092 66.3576 128.666 67.2844 128.812 68.32ZM121.493 69.8965C123.649 69.18 125.119 68.8397 125.119 68.8397C125.119 68.8397 125.327 70.3189 125.477 72.5948C125.811 77.6825 125.854 86.7517 122.625 92.1781C116.993 101.644 102.874 100.887 102.874 100.887C102.874 100.887 99.7601 88.8665 106.378 79.3328C109.798 74.406 117.081 71.3632 121.493 69.8965ZM102.874 100.887C99.2643 101.822 99.264 101.821 99.2637 101.819L99.2612 101.81L99.2569 101.793L99.2453 101.746C99.2361 101.709 99.2243 101.661 99.2103 101.601C99.1823 101.481 99.1452 101.317 99.1024 101.111C99.0168 100.7 98.9079 100.121 98.802 99.4047C98.5909 97.9764 98.3884 95.9755 98.4155 93.6416C98.4691 89.0168 99.4298 82.8025 103.314 77.2063C106.496 72.6226 112.032 69.6604 116.209 67.8997C118.383 66.9833 120.377 66.3166 121.828 65.8782C122.555 65.6583 123.152 65.494 123.575 65.3831C123.786 65.3276 123.954 65.2853 124.073 65.256C124.132 65.2413 124.179 65.2299 124.214 65.2217L124.256 65.2117L124.274 65.2074L124.278 65.2066C124.279 65.2064 124.278 65.2066 125.119 68.8397C128.812 68.32 128.812 68.3193 128.812 68.32L128.813 68.3282L128.815 68.342L128.821 68.3863L128.841 68.5402C128.858 68.6711 128.881 68.8577 128.908 69.0943C128.963 69.5673 129.033 70.2418 129.103 71.072C129.241 72.7278 129.374 75.0261 129.353 77.594C129.314 82.5189 128.714 89.2379 125.83 94.0848C122.264 100.079 116.154 102.618 111.49 103.712C109.108 104.272 106.941 104.495 105.371 104.581C104.583 104.624 103.934 104.632 103.471 104.63C103.24 104.628 103.054 104.624 102.919 104.62C102.852 104.618 102.797 104.616 102.756 104.614L102.705 104.612L102.687 104.611L102.68 104.611L102.677 104.611C102.676 104.611 102.675 104.61 102.874 100.887ZM99.2643 101.822L102.874 100.887L102.675 104.61C101.052 104.523 99.672 103.395 99.2643 101.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.133 91.9896C124.212 86.1144 123.416 73.2703 123.416 73.2703C112.06 82.9601 108.295 94.5976 107.284 98.8343C107.284 98.8343 116.055 97.8649 120.133 91.9896Z",
    fill: "#6FC21C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1274 82.5451C88.6113 83.7488 99.4491 94.978 102.148 101.571C102.373 102.122 103.881 101.444 103.691 100.963C102.388 94.8073 97.7433 80.1238 93.3109 75.3999C86.9351 74.6364 85.0587 81.1827 85.1274 82.5451Z",
    fill: "#943D31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.91 86.0699C82.472 85.5731 81.48 84.2525 81.4033 82.733C81.3522 81.7186 81.6163 80.5425 81.945 79.5617C82.3098 78.473 82.8995 77.1898 83.7977 75.9674C85.6786 73.4074 88.9656 71.1239 93.7547 71.6973C94.6251 71.8016 95.4309 72.2091 96.0307 72.8484C97.5045 74.419 98.8165 76.5984 99.9487 78.8406C101.109 81.1379 102.199 83.7435 103.169 86.3403C105.066 91.4243 106.589 96.7132 107.302 100.013C107.872 102.043 106.624 103.536 106.247 103.926C105.685 104.51 105.037 104.874 104.525 105.09C104.023 105.302 103.262 105.536 102.374 105.503C101.522 105.471 99.5536 105.076 98.6975 102.984C97.613 100.335 94.6164 96.2854 91.1891 92.5633C89.5256 90.7566 87.866 89.1416 86.4526 87.9319C85.7448 87.326 85.1335 86.8518 84.6408 86.5142C84.1954 86.209 83.9636 86.0968 83.9158 86.0736C83.9057 86.0687 83.9038 86.0678 83.91 86.0699ZM103.692 100.963C103.69 100.956 103.689 100.949 103.687 100.942C103.514 100.125 103.282 99.1591 103 98.0872C102.642 96.726 102.203 95.1937 101.7 93.578C99.6074 86.86 96.4075 78.6999 93.3113 75.4001C86.9355 74.6365 85.0591 81.1828 85.1278 82.5452C87.6394 83.413 93.9733 89.4916 98.3242 95.2872C99.2449 96.5137 100.077 97.7274 100.765 98.8765C101.277 99.7316 101.709 100.551 102.04 101.313C102.077 101.4 102.114 101.486 102.149 101.572C102.374 102.122 103.881 101.444 103.692 100.963ZM100.021 101.63C100.062 101.855 100.127 102.089 100.223 102.331C100.146 102.138 100.086 101.939 100.043 101.735C100.036 101.701 100.029 101.666 100.021 101.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5342 75.6455C95.5775 77.0038 94.504 79.579 92.1366 81.3975C89.7691 83.2159 87.0041 83.5889 85.9608 82.2306C84.9175 80.8724 85.991 78.2971 88.3585 76.4787C90.7259 74.6602 93.4909 74.2872 94.5342 75.6455Z",
    fill: "#C26649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6539 99.1992C90.3241 102.098 90.5853 110.127 86.2373 117.132C81.8892 124.137 74.5785 127.466 69.9083 124.568C65.2381 121.669 64.9769 113.64 69.3249 106.635C73.673 99.6295 80.9837 96.3005 85.6539 99.1992Z",
    fill: "#FF896F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3906 104.548C80.8353 106.016 80.8166 108.377 79.3487 109.822C78.3928 110.763 77.7269 111.79 77.3014 112.917C76.5741 114.844 74.4225 115.816 72.4956 115.089C70.5688 114.362 69.5963 112.21 70.3236 110.283C71.1484 108.098 72.4293 106.168 74.1169 104.507C75.5847 103.062 77.9458 103.081 79.3906 104.548Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_593",
    x: -2.58889,
    y: -2.58889,
    width: 210.938,
    height: 256.232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.647222,
    dy: 0.647222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.61806
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_593",
    x: 49.4386,
    y: 62.5105,
    width: 122.904,
    height: 136.495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.993115 0 0 0 0 0.743134 0 0 0 0 0.689567 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.517,
    height: 233,
    fill: "white",
    transform: "translate(22.8267) rotate(5.62216)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCard);
export default __webpack_public_path__ + "static/media/red-card.69381242bcbaa167a441db9873c46c46.svg";
export { ForwardRef as ReactComponent };